import { useState, useEffect } from 'react';
import styled from 'styled-components/macro';

import { showModal } from './showModal';

function Modal() {
  const [display, setDisplay] = useState(false);
  const [size, setSize] = useState('');
  const [content, setContent] = useState([]);

  useEffect(() => {
    const MessageBus = showModal.onMessage();
    const subscription = MessageBus.subscribe(
      ({ state, size, content }: any) => {
        setDisplay(state);
        setSize(size);
        setContent(content);
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (display) {
      window.scrollTo(0, 0);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [display]);

  return (
    <Wrapper
      display={display ? 'flex' : 'none'}
      onClick={setDisplay.bind(null, false)}
    >
      <Container className={size}>{content}</Container>
    </Wrapper>
  );
}

export default Modal;

const Wrapper = styled.div<{ display: string }>`
  display: ${(props) => props.display};
  position: absolute;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #c2c2c270;
  z-index: 100;
`;

const Container = styled.div`
  display: block;
  background-color: var(--shade-5);
  border-radius: 10px;
  &.full {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
  &.large {
    width: 85%;
    height: 85%;
  }
  &.medium {
    width: 40%;
    height: auto;
  }
`;
